
import Vue from 'vue'

interface IErrorPage {
  statusCode?: string,
  text?: string
}

export default Vue.extend({
  data () {
    return {
      error: {} as IErrorPage
    }
  },
  mounted () {
    console.log(this.$route)
    this.error = this.$route.query
  }
})
